module.exports = __webpack_public_path__ + "static/media/foto_brahma_02.5c089365.jpg";